import request from '@/utils/request'
// 获取新闻侧边栏
// export function news_sidebar(params) {
// 	return request({
// 		url: '/information/news/sidebar',
// 		method: 'get',
// 	})
// }

// 获取新闻列表
export function news_list(params) {
	return request({
		url: '/information/news/list',
		method: 'get',
		params: params,
	})
}

// 获取新闻详情
export function news_detail(params) {
	return request({
		url: '/information/news/detail',
		method: 'get',
		params: params,
	})
}

// 新增新闻
export function addNews(params) {
	return request({
		url: '/information/news/create',
		method: 'post',
		data: params,
	})
}

// 更改新闻状态
export function updateNewsStatus(params) {
	return request({
		url: '/information/news/update/status',
		method: 'post',
		data: params,
	})
}

// 删除新闻
export function deleteNews(params) {
	return request({
		url: '/information/news/delete',
		method: 'post',
		data: params,
	})
}

// 编辑时--获取新闻原始参数
export function getParams(params) {
	return request({
		url: '/information/news/get',
		method: 'get',
		params: params,
	})
}

// 编辑新闻
export function editNews(params) {
	return request({
		url: '/information/news/update',
		method: 'post',
		data: params,
	})
}
